import React from 'react';
import IconBase, { IconBaseProps } from '../IconBase';

export default function UserIcon({ size, viewBox = '0 0 18 18', ...others }: IconBaseProps) {
  return (
    <IconBase size={size} viewBox={viewBox} {...others}>
      <path
        d="M9 0a5.54 5.54 0 00-2.81.77 5.66 5.66 0 00-2.08 2 5.72 5.72 0 00-.73 2.81 5.57 5.57 0 00.73 2.82 5.37 5.37 0 002.08 2.07 5.51 5.51 0 002.81.78 5.73 5.73 0 002.81-.74 5.41 5.41 0 002-2.07 5.6 5.6 0 00.77-2.82 5.76 5.76 0 00-.77-2.81 5.7 5.7 0 00-2-2A5.76 5.76 0 009 0zm6.43 11.74a3.53 3.53 0 011.83 1.2A3.26 3.26 0 0118 15v1.3a1.66 1.66 0 01-.49 1.2 1.6 1.6 0 01-1.2.49H1.69a1.51 1.51 0 01-1.2-.49A1.51 1.51 0 010 16.31V15a3.22 3.22 0 01.7-2.07 3.52 3.52 0 011.87-1.2l2.49-.63a6.38 6.38 0 003.73 1.27 6.42 6.42 0 004.15-1.27z"
        fill="#4ec2c0"
      />
    </IconBase>
  );
}
